import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bonuses, bonusesIntro } from '../data/bonuses';
import { Section } from './Section';
export function Bonuses() {
  return <Section id="bonos" className="bg-cream" data-id="element-25" data-mp="av37exjcfd39">
      <div className="grid gap-10 lg:grid-cols-[1fr_1fr] lg:gap-20" data-id="element-26" data-mp="aua7ogisxnum">
        <div data-id="element-27" data-mp="ftmsywu0ymv3">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-clay" data-id="element-28" data-mp="ftej7dt77xo4">
            3 bonos exclusivos incluidos
          </p>
          <h2 className="mt-5 font-display text-4xl font-light leading-tight text-ink sm:text-5xl" data-id="element-29" data-mp="1whrla59ac66">
            {bonusesIntro.headline}
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-30" data-mp="3o2epa1jm0r5t">{bonusesIntro.subheadline}</p>
        </div>

        <div className="space-y-5 text-[15px] leading-relaxed text-muted lg:pt-10" data-id="element-31" data-mp="3t1rayiyqvs6t">
          {bonusesIntro.body.map(paragraph => <p key={paragraph} data-id="element-32" data-mp="1m85mtp9phwlu">{paragraph}</p>)}
          <p className="border-l-2 border-sage pl-5 font-medium text-ink" data-id="element-33" data-mp="1r9l5xbsbpt1l">
            {bonusesIntro.emphasis}
          </p>
        </div>
      </div>

      <img src={bonusesIntro.image} alt={bonusesIntro.imageAlt} className="mt-16 aspect-[16/9] w-full rounded-xl object-cover sm:aspect-[21/9]" loading="lazy" data-id="element-34" data-mp="3ic3h02asqoc6" />

      <ol className="mt-16 space-y-6" data-id="element-35" data-mp="3r8kuhc6muyb3">
        {bonuses.map(bonus => <li key={bonus.number} className="grid gap-8 rounded-xl bg-white p-6 sm:p-10 lg:grid-cols-[17rem_1fr] lg:gap-12" data-id="element-36" data-mp="3n5ofdvgaxkbw">
            <img src={bonus.image} alt={bonus.imageAlt} className="mx-auto aspect-[9/16] w-full max-w-[17rem] rounded-lg object-cover lg:sticky lg:top-8 lg:self-start" loading="lazy" data-id="element-37" data-mp="2uh0va37ah0zx" />
            <div data-id="element-38" data-mp="33ja14frm466z">
            <header className="flex flex-col gap-4 border-b border-line pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-39" data-mp="nq1asy20t0rw">
              <div data-id="element-40" data-mp="irgakymrqh3g">
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-sage-dark" data-id="element-41" data-mp="ipwvvcgrge3s">
                  Bono #{bonus.number}
                </p>
                <h3 className="mt-2 font-display text-3xl font-normal leading-tight text-ink sm:text-4xl" data-id="element-42" data-mp="3hhzjrant5xa8">
                  {bonus.title}
                </h3>
              </div>
              <p className="shrink-0 text-sm text-muted" data-id="element-43" data-mp="3lhi527jjkadl">
                Valor estimado{' '}
                <span className="font-semibold text-ink line-through decoration-clay/60" data-id="element-44" data-mp="3qglcfymzusoq">
                  ${bonus.value} USD
                </span>
                <span className="ml-2 font-semibold text-sage-dark" data-id="element-45" data-mp="2xt8q9pkqwmvy">Gratis hoy</span>
              </p>
            </header>

            <div className="grid gap-10 pt-8 lg:grid-cols-[1.1fr_0.9fr] lg:gap-14" data-id="element-46" data-mp="32sblyjeu5gr9">
              <div className="space-y-7" data-id="element-47" data-mp="37kv8i5vi3m87">
                <div data-id="element-48" data-mp="37lwlwgzzokt3">
                  <h4 className="text-sm font-semibold text-ink" data-id="element-49" data-mp="2a4ph77tvg62t">¿Qué es?</h4>
                  <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-50" data-mp="2a2cz8uo45vpr">{bonus.what}</p>
                </div>

                <div data-id="element-51" data-mp="27jzszcs4xf52">
                  <h4 className="text-sm font-semibold text-ink" data-id="element-52" data-mp="27kjaisdvi1ik">¿Por qué lo necesitas?</h4>
                  <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-53" data-mp="22kewd90ftivi">{bonus.whyLead}</p>
                  <ul className="mt-3 grid gap-x-6 gap-y-1.5 sm:grid-cols-2" data-id="element-54" data-mp="1xlk65m054s1d">
                    {bonus.whyPoints.map(point => <li key={point} className="text-[15px] text-ink" data-id="element-55" data-mp="1tjgqel6fv1aa">
                        {point}
                      </li>)}
                  </ul>
                  <p className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-56" data-mp="1ju5iv2z7a4oi">{bonus.whyClose}</p>
                </div>

                <div className="rounded-lg bg-sage-light p-5" data-id="element-57" data-mp="1ew41cmhfadf5">
                  <h4 className="text-sm font-semibold text-sage-dark" data-id="element-58" data-mp="19wj2ec29652f">El resultado real</h4>
                  {bonus.result.map(paragraph => <p key={paragraph} className="mt-2 text-[15px] leading-relaxed text-ink" data-id="element-59" data-mp="15u4jxt2hx7bo">
                      {paragraph}
                    </p>)}
                </div>
              </div>

              <div data-id="element-60" data-mp="30ylzaexej9mq">
                <h4 className="text-sm font-semibold text-ink" data-id="element-61" data-mp="34zecfj9e9yoa">¿Qué incluye?</h4>
                <ul className="mt-4 divide-y divide-line border-y border-line" data-id="element-62" data-mp="351id7sbzyhkc">
                  {bonus.includes.map(item => <li key={item} className="flex gap-3 py-3 text-[15px] leading-snug text-ink" data-id="element-63" data-mp="2w6ub2b1pxfzr">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-64" data-mp="2ha36lnd6te3a" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
            </div>
          </li>)}
      </ol>
    </Section>;
}